import React from 'react';
import ProcurementTable from './ProcurementTable';

const ProductHydroTable = ({ refreshTrigger }) => (
  <ProcurementTable procurementTypeHeader='1' refreshTrigger={refreshTrigger} />
);

export default React.memo(ProductHydroTable);
